<template>
  <button
      type="button"
      class="excel-export-button"
      :disabled="loading"
      @click="$emit('click')">

    <span
        v-if="loading"
        class="spinner-border spinner-border-sm excel-spinner"
        role="status"
        aria-hidden="true">
    </span>

<!--    <i v-else class="fa-solid fa-file-excel excel-export-icon"></i>-->
    <i v-else class="fa-regular fa-file-excel excel-export-icon"></i>
    <span class="excel-export-text">
      {{ loading ? $t('general.button.generating_document') : label }}
    </span>
  </button>
</template>

<script setup>
import { computed, defineEmits, defineProps } from 'vue';
import { piniaCompanySettingsStore } from "@/store/piniaCompanySettingsStore";

const piniaCompanySettingsState = piniaCompanySettingsStore()
const companySettings = computed(() => piniaCompanySettingsState.companySettings)

const companyColor = computed(() => companySettings.value?.colorCode || '#15803d')

const companyBgColor = computed(() => companySettings.value?.colorCode
    ? `${companySettings.value.colorCode}15`
    : '#ecfdf5'
)

defineProps({
  label: {
    type: String,
    default: 'Excel-Export'
  },
  loading: {
    type: Boolean,
    default: false
  }
})

defineEmits(['click'])
</script>

<style scoped>
.excel-export-button {
  display: inline-flex;
  align-items: center;
  gap: 10px;

  border: 1px solid v-bind(companyColor);
  color: v-bind(companyColor);
  background-color: v-bind(companyBgColor);

  padding: 6px 14px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;
}

.excel-export-button:hover:not(:disabled) {
  filter: brightness(0.96);
  transform: translateY(-1px);
}

.excel-export-icon {
  font-size: 20px;
  color: v-bind(companyColor);
  transition: transform 0.2s ease;
}

.excel-export-button:hover:not(:disabled) .excel-export-icon {
  transform: scale(1.1);
}

.excel-spinner {
  width: 16px;
  height: 16px;
  border-width: 2px;
  color: v-bind(companyColor);
}

.excel-export-button:disabled {
  cursor: not-allowed;
  opacity: 0.75;
  filter: grayscale(20%);
}

.excel-export-text {
  white-space: nowrap;
}

@media (max-width: 640px) {
  .excel-export-button {
    width: 100%;
    justify-content: center;
    margin-bottom: 10px;
    margin-top: 20px;
    margin-right: 0;
  }
}
</style>